export const API_BASE_URL = process.env.REACT_APP_BASE_URL || 'https://dev-api.54dnatype.com'
export const REACT_APP_REDIRECT_URL = process.env.REACT_APP_REDIRECT_URL || 'http://localhost:3000/kakao/login'
export const REACT_APP_KAKAO_CONNECT_REDIRECT_URL = process.env.REACT_APP_KAKAO_CONNECT_REDIRECT_URL || 'http://localhost:3000/kakao/link'
// export const REACT_APP_REDIRECT_URL='https://pr-206.d1hwd9logdni7.amplifyapp.com/kakao/login'
export const REACT_APP_KAKAO_URL = 'https://kauth.kakao.com'
export const REACT_APP_KAKAO_API_URL = 'https://kapi.kakao.com/v2/user/me'
export const REACT_APP_REST_API_KEY = process.env.REACT_APP_REST_API_KEY || '265bed565f395c4d868cae28f78b4526'
export const REACT_APP_JS_KEY = process.env.REACT_APP_JS_KEY || '3a3db63e7331d14733ae1365682386e0'
